export const defaultAddresses = {
  nativeTokenBridgePrecompileAddress: '0xff00000000000000000000000000000000000001',
  nonNativeTokenBridgePrecompileAddress: '0xff00000000000000000000000000000000000002'
} as const;
